import { MILESTONES_ALIAS } from '../useMilestonesService';
import { MilestonesType } from '../types';

const PROTECTED_MILESTONE_TYPES = [
  MILESTONES_ALIAS.ADVANCED_PAYMENT,
  MILESTONES_ALIAS.PROGRESS_BILLING,
  MILESTONES_ALIAS.ACCEPTANCE_MILESTONE,
] as const;

export const isProtectedMilestone = (milestone: MilestonesType): boolean => {
  return PROTECTED_MILESTONE_TYPES.includes(milestone.type as (typeof PROTECTED_MILESTONE_TYPES)[number]);
};
